'use strict';

import './MinecraftEditionSupportSummary.less';

import React from 'react';
import lang from './MinecraftEditionSupportSummaryLang';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';

export default class MinecraftEditionSupportSummary extends React.Component {
	render() {
		let editions = [];

		lang.EDITIONS.forEach(editionLang => {
			editions.push(
				<div className="edition" key={editionLang.NAME}>
					<div className="icon">
						<ReactCKImage name={editionLang.ICON} />
					</div>
					<div className="editionName"> {editionLang.NAME} </div>
				</div>
			);
		});

		return (
			<div className="MinecraftEditionSupportSummary">
				<div className="header">{lang.HEADER}</div>
				<div className="editions">{editions}</div>
				<div className="blurb" dangerouslySetInnerHTML={{ __html: lang.BLURB }} />
			</div>
		);
	}
}
